import React from "react";
import { TextField } from "@mui/material";
import { TextQuestion } from "../../types";
import { validateTextRule } from "../../utils/fieldValidation";

interface TextQuestionProps {
  question: TextQuestion;
  value: string;
  onChange: (value: string) => void;
}

export const TextQuestionField: React.FC<TextQuestionProps> = ({
  question,
  value,
  onChange,
}) => {
  const rule = question.validation;
  const error = validateTextRule(rule, value);
  const showError = value.trim().length > 0 && error !== null;
  const isSingleLine = rule === "email" || rule === "phone_uk";

  return (
    <TextField
      fullWidth
      multiline={!isSingleLine}
      minRows={isSingleLine ? undefined : 3}
      type={rule === "email" ? "email" : rule === "phone_uk" ? "tel" : "text"}
      placeholder={question.placeholder}
      value={value}
      onChange={(event) => onChange(event.target.value)}
      error={showError}
      helperText={showError ? error : ""}
    />
  );
};
